export const SET_STORE_CONFIG = 'SET_STORE_CONFIG'

export const SET_JOB = 'SET_JOB'
export const SET_JOB_CONFIG = 'SET_JOB_CONFIG'
export const SET_JOB_SETTING = 'SET_JOB_SETTING'
export const UPDATE_JOB_CONFIG = 'UPDATE_JOB_CONFIG'

export const STEP_UP_DOWN = 'STEP_UP_DOWN'
export const RESET_EVERYTHING = 'RESET_EVERYTHING'
